module.exports = __webpack_public_path__ + "img/prev-arrow.8d4441e1.svg";